<template>
  <div class="card h-100 shadow-sm">
    <div class="card-header d-flex justify-content-between align-items-center">
      <span>{{title}}</span>
    </div>
    <div class="ratio ratio-21x9">
      <canvas ref="chartBlock" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import Chart from 'chart.js/auto'


const props = defineProps({
  platformData: { type: Array, default: () => [] },
  title: { type: String, default: () => "" }
})
const chartBlock = ref(null)

let chart3

/** Helper: разрушить ранее созданный график */
function destroy(ch) {
  if (ch) {
    ch.destroy()
  }
}

/** Создать круговую диаграмму платформ */
function createChartBlock() {
  destroy(chart3)
  const labels = props.platformData.map(p => p.platform)
  const data = props.platformData.map(p => p.value)
  const colors = [
    'rgba(13,110,253,.8)',  // primary
    'rgba(25,135,84,.8)',   // success
    'rgba(255,193,7,.8)',   // warning
    'rgba(220,53,69,.8)',   // danger
    'rgba(108,117,125,.8)'  // secondary
  ]
  chart3 = new Chart(chartBlock.value, {
    type: 'pie',
    data: {
      labels,
      datasets: [{
        data,
        backgroundColor: data.map((_, i) => colors[i % colors.length])
      }]
    },
    options: {
      plugins: {
        legend: { position: 'bottom' }
      },
      responsive: true,
      maintainAspectRatio: false
    }
  })
}

onMounted(() => {
  createChartBlock()
})
watch(() => props.platformData, createChartBlock, { deep: true })
</script>

<style scoped>
.card {
  overflow: hidden;
}
</style>
